// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18YUF","questions":"styles_questions__UVjT_","footer":"styles_footer__2wl8G"};